import { Component } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { AuthService } from 'src/app/core/auth.service';
import { ErrorService } from 'src/app/core/error.service';
import { FormErrorStateMatcher, FormService } from 'src/app/core/form.service';
import { NavigationService } from 'src/app/core/navigation.service';
import {
  ERROR_MFA_REQUIRED_CODE,
  ERROR_MFA_SETUP_CODE,
  ERROR_NEW_PASSWORD_REQUIRED_CODE,
  LOCAL_USERNAME_KEY,
} from 'src/app/shared/constants/operationals';

@Component({
  selector: 'app-auth-signin-form',
  templateUrl: './auth-signin-form.component.html',
  styleUrls: ['./auth-signin-form.component.scss'],
})
export class AuthSigninFormComponent {
  signin_form_group: FormGroup = this.form_service.auth_signin_form_group;
  error_matcher: FormErrorStateMatcher = this.form_service.matcher;
  is_password_visible: boolean = false;
  is_signin_running: boolean = false;

  constructor(
    private form_service: FormService,
    private auth_service: AuthService,
    private error_service: ErrorService,
    private navigation_service: NavigationService,
  ) {}

  onSigninClick(): void {
    if (this.isFormValid()) {
      const username: string = this.signin_form_group.get(this.form_service.email_label)?.value;
      const password: string = this.signin_form_group.get(this.form_service.password_label)?.value;
      this.signin(username, password);
    }
  }

  onPssResetClick(): void {
    this.auth_service.onForgotPssClick();
  }

  signin(username: string, password: string): void {
    this.is_signin_running = true;
    this.auth_service.signin(username, password).subscribe({
      next: response => {
        if (response.challengeName == ERROR_NEW_PASSWORD_REQUIRED_CODE) {
          this.auth_service.pending_cognito_user = response;
          this.navigation_service.toAuthNewPassword();
        } else if (
          response.challengeName == ERROR_MFA_REQUIRED_CODE ||
          response.challengeName == ERROR_MFA_SETUP_CODE
        ) {
          this.auth_service.pending_cognito_user = response;
          this.navigation_service.toAuthMfa();
        } else {
          this.navigation_service.toHome();
          localStorage.setItem(LOCAL_USERNAME_KEY, response.attributes.email);
        }
        this.is_signin_running = false;
      },
      error: error => {
        this.error_service.processApiError(error.code, error.message);
        this.is_signin_running = false;
      },
    });
  }

  isFormValid(): boolean {
    return this.form_service.validateForm(this.signin_form_group);
  }
}
